import { createWebHistory, createRouter } from 'vue-router';
import { authGuard } from './auth-guard';

const routes = [
	{path: '/:catchAll(.*)', redirect:{name:'Login'}},
	{
		path:'/login',
		name:'Login',
		component:()=>import('@/components/authentication/Layout.vue')
	},{
		path:'/admin',
		name:'PageLayout',
		beforeEnter:authGuard,
		component:()=>import('@/components/authentication/PageLayout.vue'),
		children:[
			{
				path:'/dashboard',
				name:'Dashboard',
				component:()=>import('@/components/Pages/dashboard.vue')
			},
			{
				path:'/interfaces',
				name:'Buckets',
				component:()=>import('@/components/Pages/buckets.vue')
			},
			{
				path:'/logout',
				name:'Logout',
				component:()=>import('@/components/authentication/Logout.vue')
			},
			

		]
	}
];

const router = createRouter({
	history: createWebHistory(),
	hash:false,
	routes,
});

export default router;